import { z } from 'zod';

/** CRM-Aktivität / Verlaufseintrag (ADR 0005, CRM-Ausbau). */
export const crmActivityTypeSchema = z.enum(['NOTE', 'CALL', 'EMAIL', 'MEETING', 'TASK']);
export type CrmActivityType = z.infer<typeof crmActivityTypeSchema>;

export const createCrmActivitySchema = z.object({
  type: crmActivityTypeSchema,
  subject: z.string().trim().min(1).max(200),
  content: z.string().trim().max(5000).optional(),
  contactId: z.string().uuid().optional(),
  occurredAt: z.string().datetime().optional(),
  dueDate: z.string().datetime().optional(),
  isDone: z.boolean().default(false),
});
export type CreateCrmActivityInput = z.infer<typeof createCrmActivitySchema>;

export const updateCrmActivitySchema = z.object({
  type: crmActivityTypeSchema.optional(),
  subject: z.string().trim().min(1).max(200).optional(),
  content: z.string().trim().max(5000).nullable().optional(),
  contactId: z.string().uuid().nullable().optional(),
  occurredAt: z.string().datetime().optional(),
  dueDate: z.string().datetime().nullable().optional(),
  isDone: z.boolean().optional(),
});
export type UpdateCrmActivityInput = z.infer<typeof updateCrmActivitySchema>;

export const crmActivityResponseSchema = z.object({
  id: z.string().uuid(),
  customerId: z.string().uuid(),
  type: crmActivityTypeSchema,
  subject: z.string(),
  content: z.string().nullable(),
  contactId: z.string().uuid().nullable(),
  occurredAt: z.string().datetime(),
  dueDate: z.string().datetime().nullable(),
  isDone: z.boolean(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type CrmActivityResponse = z.infer<typeof crmActivityResponseSchema>;
